export default __webpack_public_path__ + "static/media/FOTO JERSU ~1080 2.10931166.png";